<template>
<div class="text-center mx-md-auto">
    <i class="nch--icon fas mb-2" :class="icon"/>
    <slot name="title"/>
    <slot name="subtitle"/>
    <button
        v-if="!!buttonLabel"
        @click="$emit('redirect', $event)"
        :style="[$bgColor(color.primary), { color: color.secondary }]"
        class="btn"
    >
        {{ buttonLabel }}
    </button>
</div>
</template>

<script>
export default {
    name: 'Empty',
    props: {
        icon: {
            type: String,
            required: true,
        },
        buttonLabel: {
            type: String,
        },
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
    },
};
</script>

<style scoped>
    .nch--icon {
        font-size: 5em;
    }
</style>
